import { NgModule } from "@angular/core";
import { KeeniconComponent } from "./keenicon/keenicon.component";
import { CommonModule, DatePipe } from "@angular/common";
import { InputComponent } from "./input/input.component";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  NgxMaskConfig,
  NgxMaskDirective,
  NgxMaskPipe,
  provideEnvironmentNgxMask,
  provideNgxMask,
} from "ngx-mask";
import { DatepickerComponent } from "./datepicker/datepicker.component";
import {
  NgbDatepickerModule,
  NgbModalModule,
  NgbTimepickerModule,
  NgbTooltipModule,
  NgbTypeaheadModule,
} from "@ng-bootstrap/ng-bootstrap";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { NgSelectModule } from "@ng-select/ng-select";
import { SelectComponent } from "./select/select.component";
import { TextareaComponent } from "./textarea/textarea.component";
import { CheckboxComponent } from "./checkbox/checkbox.component";
import { DaterangePickerComponent } from "./daterange-picker/daterange-picker.component";
import { SwitchComponent } from "./switch/switch.component";
import { StatusLoadingComponent } from "./status-loading/status-loading.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { RadioComponent } from "./radio/radio.component";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { NgxFileDropModule } from "ngx-file-drop";
import { TimepickerComponent } from "./timepicker/timepicker.component";
import { DatatableComponent } from "./datatable/datatable.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { ScreenSizeDetectorComponent } from "./screen-size-detector/screen-size-detector.component";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { BEDatePipe } from "src/utils/pipes/bedate.pipe";
import { TableWidgetComponent } from "./_tables/table-widget/table-widget.component";
import { PaginationsComponent } from "./_tables/course-table/paginations/paginations/paginations.component";
import { ProgressLoadingComponent } from "./progress-loading/progress-loading.component";
import { BannerImageComponent } from "./banner-image/banner-image.component";
import { IconSvgComponent } from "./icon-svg/icon-svg.component";
import { UploadImageComponent } from "./upload-image/upload-image.component";
import { CourseTableWidgetComponent } from "./_tables/course-table/course-table-widget/course-table-widget.component";
import { PipesModule } from "src/utils/pipes/pipes.module";
import { ReviewTableWidgetComponent } from "./_tables/course-table/review-table-widget/review-table-widget.component";
import { BreadcrumbCustomComponent } from "./breadcrumb-custom/breadcrumb-custom.component";
import { RouterModule } from "@angular/router";
import { RatingStarComponent } from "src/shared/rating-star/rating-star.component";
import { NgApexchartsModule } from "ng-apexcharts";
import { CircleProgressChartComponent } from "./_charts/circle-progress-chart/circle-progress-chart.component";
import { ColumnChartComponent } from "./_charts/column-chart/column-chart.component";
import { NgxPermissionsModule } from "ngx-permissions";

const maskConfig: Partial<NgxMaskConfig> = {
  validation: true,
  dropSpecialCharacters: true,
};

@NgModule({
  declarations: [
    KeeniconComponent,
    InputComponent,
    DatepickerComponent,
    DaterangePickerComponent,
    SelectComponent,
    TextareaComponent,
    CheckboxComponent,
    SwitchComponent,
    StatusLoadingComponent,
    RadioComponent,
    FileUploadComponent,
    TimepickerComponent,
    DatatableComponent,
    ScreenSizeDetectorComponent,
    TableWidgetComponent,
    PaginationsComponent,
    ProgressLoadingComponent,
    BannerImageComponent,
    IconSvgComponent,
    UploadImageComponent,
    CourseTableWidgetComponent,
    ReviewTableWidgetComponent,
    BreadcrumbCustomComponent,
    RatingStarComponent,
    CircleProgressChartComponent,
    ColumnChartComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgSelectModule,
    NgbTypeaheadModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    NgxFileDropModule,
    NgbTimepickerModule,
    NgxDatatableModule,
    SweetAlert2Module.forChild(),
    NgbModalModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    NgxMaskDirective,
    NgxMaskPipe,
    PipesModule,
    RouterModule,
    NgbTooltipModule,
    NgApexchartsModule,
    NgxPermissionsModule,
  ],
  exports: [
    KeeniconComponent,
    InputComponent,
    DatepickerComponent,
    DaterangePickerComponent,
    SelectComponent,
    TextareaComponent,
    CheckboxComponent,
    SwitchComponent,
    StatusLoadingComponent,
    RadioComponent,
    FileUploadComponent,
    TimepickerComponent,
    DatatableComponent,
    ScreenSizeDetectorComponent,
    TableWidgetComponent,
    BannerImageComponent,
    IconSvgComponent,
    UploadImageComponent,
    CourseTableWidgetComponent,
    ReviewTableWidgetComponent,
    BreadcrumbCustomComponent,
    RatingStarComponent,
    CircleProgressChartComponent,
    ColumnChartComponent,
    NgxPermissionsModule,
  ],
  providers: [
    provideNgxMask(),
    provideEnvironmentNgxMask(maskConfig),
    MatDatepickerModule,
    DatePipe,
    BEDatePipe,

    { provide: MAT_DATE_LOCALE, useValue: "th-TH" },
    // { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
  ],
})
export class SharedModule {}
